const type = 'SET_SELECTED_PERIOD_TIMELINE_TO_PRE_PAID';

const setSelectedPeriodTimelineToPrePaid = (data = {}) => ({
  data,
  type,
});

export { type };
export default setSelectedPeriodTimelineToPrePaid;
